module.exports = __webpack_public_path__ + "static/media/ImgReceptionSmallJp.be299832.svg";